import { render, staticRenderFns } from "./Ispisi.vue?vue&type=template&id=5fe3608a&scoped=true&"
import script from "./Ispisi.vue?vue&type=script&lang=js&"
export * from "./Ispisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe3608a",
  null
  
)

export default component.exports